import { BasicValueUnitGetModuleFactory } from '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import { PricesListModuleFactory } from '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import { AlertingPricesBasicTriggerCreateModuleFactory } from '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import { AlertingPricesBasicTriggerDeleteModuleFactory } from '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import { AlertingPricesBasicTriggerListModuleFactory } from '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import { AlertingPricesBasicTriggerModifyModuleFactory } from '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import '../../subscriptions/news/article/searchByText.module.js';
import '../../subscriptions/news/article/listByMediaKind.module.js';
import { PricesGetSubscriptionModuleFactory } from '../../subscriptions/prices/get.module.js';
import '../../subscriptions/prices/bidAsk/get.module.js';
import '../../subscriptions/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../subscriptions/alerting/prices/basic/alert/list.module.js';
import '../../subscriptions/prices/orderbook/aggregated/get.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { FactsheetHeaderStoreModuleFactory } from '../factsheet-header/index.module.js';
import { getEndpointOptions, inheritEndpointOptions } from '../../helpers/common.js';

var _a, _b, _c, _d, _e, _f, _g, _h, _i;
class AlertTriggerControlsStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.paginationLimit = 500;
    this.isPricesPushEnabled = (_c = (_b = (_a = this.options) == null ? void 0 : _a.push) == null ? void 0 : _b.enabled) != null ? _c : true;
    this.quality = (_f = (_e = (_d = this.options) == null ? void 0 : _d.prices) == null ? void 0 : _e.quality) != null ? _f : "BST";
    this.sameQuality = (_i = (_h = (_g = this.options) == null ? void 0 : _g.prices) == null ? void 0 : _h.sameQuality) != null ? _i : false;
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  async updateComponentsInputs(payload) {
    let status = true;
    try {
      switch (payload.action) {
        case "FETCH":
          await this.fetchTriggerList(payload);
          break;
        case "SAVE":
          await this.saveTrigger(payload);
          break;
        case "DELETE":
          await this.deleteTrigger(payload);
          break;
        default:
          throw new Error("Unknown action");
      }
    } catch (error) {
      this.logger.error(error);
      status = false;
    }
    return Promise.resolve(status);
  }
  async cleanUp(payload) {
    let isResponseSuccessful = true;
    try {
      if (this.isPricesPushEnabled) {
        await this.removeInactivePricesGetSubscription(payload);
      }
    } catch (e) {
      this.logger.error(e);
      isResponseSuccessful = false;
    }
    return Promise.resolve(isResponseSuccessful);
  }
  getEndpoints() {
    var _a2, _b2, _c2, _d2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      const pricesGetSubscriptionOptions = {
        granularity: (_d2 = (_c2 = (_b2 = this.options) == null ? void 0 : _b2.push) == null ? void 0 : _c2.granularity) != null ? _d2 : "1S",
        quality: this.quality,
        ...getEndpointOptions(endpointConfiguration, "pricesGetSubscription")
      };
      this.endpoints = {
        alertingPricesBasicTriggerList: this.getModuleEntity(
          AlertingPricesBasicTriggerListModuleFactory,
          getEndpointOptions(endpointConfiguration, "alertingPricesBasicTriggerList")
        ),
        alertingPricesBasicTriggerCreate: this.getModuleEntity(
          AlertingPricesBasicTriggerCreateModuleFactory,
          getEndpointOptions(endpointConfiguration, "alertingPricesBasicTriggerCreate")
        ),
        alertingPricesBasicTriggerDelete: this.getModuleEntity(
          AlertingPricesBasicTriggerDeleteModuleFactory,
          getEndpointOptions(endpointConfiguration, "alertingPricesBasicTriggerDelete")
        ),
        alertingPricesBasicTriggerModify: this.getModuleEntity(
          AlertingPricesBasicTriggerModifyModuleFactory,
          getEndpointOptions(endpointConfiguration, "alertingPricesBasicTriggerModify")
        ),
        pricesList: this.getModuleEntity(PricesListModuleFactory, getEndpointOptions(endpointConfiguration, "pricesList")),
        pricesGetSubscription: this.getModuleEntity(PricesGetSubscriptionModuleFactory, pricesGetSubscriptionOptions),
        basicValueUnitGet: this.getModuleEntity(BasicValueUnitGetModuleFactory, getEndpointOptions(endpointConfiguration, "basicValueUnitGet"))
      };
    }
    return this.endpoints;
  }
  getDependencies() {
    var _a2, _b2;
    if (!this.dependencies) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      const genericAdditionalData = ["isin", "country"];
      const factsheetHeader = new FactsheetHeaderStoreModuleFactory({
        mdg2Client: this.mdg2Client,
        logger: this.logger,
        store: this.store,
        options: {
          assetClass: {
            generic: {
              additionalData: genericAdditionalData
            }
          },
          ...inheritEndpointOptions(endpointConfiguration, (_b2 = this.options) == null ? void 0 : _b2.factsheetHeader)
        }
      });
      this.dependencies = {
        factsheetHeader
      };
    }
    return this.dependencies;
  }
  getAlertingPricesBasicTriggerListRequest() {
    return {
      meta: {
        pagination: {
          limit: this.paginationLimit
        }
      }
    };
  }
  getAlertingPricesBasicTriggerListData() {
    var _a2;
    const request = this.getAlertingPricesBasicTriggerListRequest();
    const response = this.getEndpoints().alertingPricesBasicTriggerList.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateAlertingPricesBasicTriggerList() {
    try {
      const request = this.getAlertingPricesBasicTriggerListRequest();
      return this.getEndpoints().alertingPricesBasicTriggerList.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getPricesListNotationDataRequest(id) {
    return { id, quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListRequest(identifiers) {
    return { identifiers, identifierType: "idNotation", quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListData(payload) {
    var _a2;
    const request = this.getPricesListNotationDataRequest(payload.securityId);
    const response = this.getEndpoints().pricesList.getNotationData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updatePricesList(payload) {
    try {
      const request = this.getPricesListRequest([payload.securityId]);
      return this.getEndpoints().pricesList.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getPricesGetSubscriptionRequest(identifier) {
    return { identifier, identifierType: "idNotation", quality: this.quality };
  }
  getPricesGetSubscriptionData(payload) {
    var _a2;
    const request = this.getPricesGetSubscriptionRequest(payload.securityId);
    const response = this.getEndpoints().pricesGetSubscription.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updatePricesGetSubscription(payload) {
    const request = this.getPricesGetSubscriptionRequest(payload.securityId);
    return this.getEndpoints().pricesGetSubscription.fetchObservable(request);
  }
  async removeInactivePricesGetSubscription(payload) {
    const request = this.getPricesGetSubscriptionRequest(payload.securityId);
    return this.getEndpoints().pricesGetSubscription.removeSubscriptionIfInactive(request);
  }
  getBasicValueUnitGetRequest(id) {
    return { id };
  }
  getBasicValueUnitGetData(payload) {
    var _a2, _b2;
    try {
      const valueUnitId = (_a2 = this.getPricesListData(payload)) == null ? void 0 : _a2.valueUnit.id;
      if (!valueUnitId) {
        throw new Error("could not get value unit id");
      }
      const request = this.getBasicValueUnitGetRequest(valueUnitId);
      const response = this.getEndpoints().basicValueUnitGet.getData(request);
      return (_b2 = response == null ? void 0 : response.data) != null ? _b2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateBasicValueUnitGet(payload) {
    var _a2;
    await this.updatePricesList(payload);
    const valueUnitId = (_a2 = this.getPricesListData(payload)) == null ? void 0 : _a2.valueUnit.id;
    if (!valueUnitId) {
      throw new Error("could not get value unit id");
    }
    const request = this.getBasicValueUnitGetRequest(valueUnitId);
    return this.getEndpoints().basicValueUnitGet.updateState(request);
  }
  getAlertingPricesBasicTriggerModifyRequest(id, upperLimit, lowerLimit) {
    return {
      data: {
        id,
        range: {
          ...upperLimit && { upperLimit },
          ...lowerLimit && { lowerLimit }
        }
      }
    };
  }
  async updateAlertingPricesBasicTriggerModify(id, payload) {
    try {
      const request = this.getAlertingPricesBasicTriggerModifyRequest(id, payload.limit.above, payload.limit.below);
      return this.getEndpoints().alertingPricesBasicTriggerModify.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getAlertingPricesBasicTriggerCreateRequest(id, upperLimit, lowerLimit) {
    return {
      data: {
        notation: {
          id
        },
        price: {
          type: "trade",
          quality: "BST"
        },
        range: {
          ...upperLimit && { upperLimit },
          ...lowerLimit && { lowerLimit }
        }
      }
    };
  }
  async updateAlertingPricesBasicTriggerCreate(id, payload) {
    try {
      const request = this.getAlertingPricesBasicTriggerCreateRequest(id, payload.limit.above, payload.limit.below);
      return this.getEndpoints().alertingPricesBasicTriggerCreate.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getAlertingPricesBasicTriggerDeleteRequest(id) {
    return {
      data: {
        id
      }
    };
  }
  async updateAlertingPricesBasicTriggerDelete(id) {
    try {
      const request = this.getAlertingPricesBasicTriggerDeleteRequest(id);
      return this.getEndpoints().alertingPricesBasicTriggerDelete.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getTriggerStatus(trigger) {
    return trigger ? trigger.status.code === "active" ? "active" : "inactive" : null;
  }
  getResponseData(payload) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    const triggerListResults = this.getAlertingPricesBasicTriggerListData();
    const trigger = (triggerListResults != null ? triggerListResults : []).find((item) => item.notation.id === payload.securityId);
    const priceData = this.getPricesListData(payload);
    const pricesSubscriptionData = this.isPricesPushEnabled ? this.getPricesGetSubscriptionData(payload) : null;
    const valueUnit = this.getBasicValueUnitGetData(payload);
    return {
      id: (_a2 = trigger == null ? void 0 : trigger.id) != null ? _a2 : null,
      status: this.getTriggerStatus(trigger),
      lastPrice: (_c2 = (_b2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.latest.price) != null ? _b2 : priceData == null ? void 0 : priceData.latest.price) != null ? _c2 : null,
      currency: (_e2 = (_d2 = valueUnit == null ? void 0 : valueUnit.code) != null ? _d2 : valueUnit == null ? void 0 : valueUnit.isoCode) != null ? _e2 : null,
      limit: {
        above: (_f2 = trigger == null ? void 0 : trigger.range.upperLimit) != null ? _f2 : null,
        below: (_g2 = trigger == null ? void 0 : trigger.range.lowerLimit) != null ? _g2 : null
      }
    };
  }
  getResponseMeta(payload) {
    return {
      validationRules: {
        upperLimit: { pattern: /^\d+(\.\d+)?$/ },
        lowerLimit: { pattern: /^\d+(\.\d+)?$/ }
      }
    };
  }
  async fetchTriggerList(payload) {
    try {
      await this.updateAlertingPricesBasicTriggerList();
      await this.updatePricesList(payload);
      if (this.isPricesPushEnabled) {
        this.updatePricesGetSubscription(payload);
      }
      return Promise.resolve(true);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  isValidTrigger(payload) {
    return !payload.limit.above && !payload.limit.below;
  }
  async saveTrigger(payload) {
    try {
      if (this.isValidTrigger(payload)) {
        throw new Error("At least 1 limit should be populated");
      }
      const triggerIdentifier = await this.fetchTriggerIdentifier(payload);
      if (triggerIdentifier) {
        await this.updateAlertingPricesBasicTriggerModify(triggerIdentifier, payload);
        await this.fetchTriggerList(payload);
        return Promise.resolve(true);
      }
      await this.updateAlertingPricesBasicTriggerCreate(payload.securityId, payload);
      await this.fetchTriggerList(payload);
      return Promise.resolve(true);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  async deleteTrigger(payload) {
    try {
      const triggerIdentifier = await this.fetchTriggerIdentifier(payload);
      if (triggerIdentifier) {
        await this.updateAlertingPricesBasicTriggerDelete(triggerIdentifier);
        await this.fetchTriggerList(payload);
      }
      return Promise.resolve(true);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  async fetchTriggerIdentifier(payload) {
    var _a2;
    try {
      await this.updateAlertingPricesBasicTriggerList();
      const triggerListResults = this.getAlertingPricesBasicTriggerListData();
      const triggerIdentifier = (_a2 = (triggerListResults != null ? triggerListResults : []).find((trigger) => trigger.notation.id === payload.securityId)) == null ? void 0 : _a2.id;
      return triggerIdentifier;
    } catch (e) {
      this.logger.error(e);
      return void 0;
    }
  }
}

export { AlertTriggerControlsStoreModuleFactory };
